import { NetworkCriteriaType } from 'components/common/types/DirectSalesNetworks.types';
import { UseNetworkTarget } from 'components/common/types/UseNetworkTarget.types';
import { TargetLabel } from 'consts/targetLabel';
import { IconSize } from 'components/common/types/Input.types';
import { MinMax } from 'components/common/types/Range.types';
import { UseTarget } from '../components/TargetsPanel/TargetsPanel.types';

export enum TargetType {
  BUDGET = 'budget',
  FRAMES = 'frames',
  IMPRESSIONS = 'impressions',
  NETWORK = 'networks',
}

export interface TargetSectionProps {
  label?: TargetLabel;
  range?: MinMax;
  errorMessage?: string;
  hasBorder?: boolean;
  target: UseTarget | UseNetworkTarget;
  targetType: TargetType;
  icon?: string;
  iconSize?: IconSize;
  currentOption?: NetworkCriteriaType;
  isTargetValueRequired?: boolean;
  isDisabled?: boolean;
  isRange?: boolean;
  isAutoFocus?: boolean;
  dataPendoId?: string;
  isProgrammaticDeal?: boolean;
  chipVisibility?: {
    available?: boolean;
    inNetwork?: boolean;
    allocated?: boolean;
  };
}
